'use client';

import React__default from 'react';

var CircleArrowRightIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b;
    return (React__default.createElement("svg", { width: width, height: width, viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("g", { id: 'Circled Right' },
            React__default.createElement("path", { id: 'Vector', d: 'M10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2ZM13.8047 10.4713L11.138 13.138C11.008 13.268 10.8373 13.3333 10.6667 13.3333C10.496 13.3333 10.3253 13.268 10.1953 13.138C9.93467 12.8773 9.93467 12.456 10.1953 12.1953L11.724 10.6667H6.66667C6.29867 10.6667 6 10.3687 6 10C6 9.63133 6.29867 9.33333 6.66667 9.33333H11.724L10.1953 7.80467C9.93467 7.544 9.93467 7.12267 10.1953 6.862C10.456 6.60133 10.8773 6.60133 11.138 6.862L13.8047 9.52867C14.0653 9.78933 14.0653 10.2107 13.8047 10.4713Z', fill: 'white' }))));
};

export { CircleArrowRightIcon as default };
//# sourceMappingURL=index.js.map
